import { connect } from 'react-redux';
import { mapValues, defaults, map, get, set } from 'lodash';
import { DataForm } from '../data-form';
import { actions } from '@comall-backend-builder/core';

function mapDispatchToProps(dispatch, props) {
  var componentId = props.componentId,
      entity = props.entity,
      fieldsFromProps = props.fields,
      onInit = props.onInit,
      onSubmit = props.onSubmit,
      onReset = props.onReset;

  var handleInit = function handleInit() {
    var entityId = entity.id,
        properties = entity.metainfo.properties;
    var fields = {};
    map(fieldsFromProps, function (field) {
      var property = field.property; // 从实体中获取属性配置，实体中的 path 为 style.properties.color，配置中 path 为 style.color

      var entityProperty = get(properties, property.replace(/\./g, '.properties.'));

      if (entityProperty) {
        set(fields, property, entityProperty.defaultValue || undefined);
      } else {
        throw new Error("Property " + property + " not found in Entity " + entityId);
      }
    });
    dispatch(actions.formInitAction(componentId, {
      type: 'CreateForm',
      entityId: entity.id,
      fields: fields
    }));
  };

  return defaults({
    onInit: onInit,
    onSubmit: onSubmit,
    onReset: onReset
  }, {
    // 初始化表单结构
    onInit: handleInit,
    // 提交表单
    onSubmit: function onSubmit(_event, fields) {
      if (_event) {
        _event.stopPropagation();
      }

      var entityFields = mapValues(fields, function (field, _name) {
        return field.value;
      });
      entity.add(entityFields, props.params);
    },
    onSubmitStart: function onSubmitStart() {
      dispatch(actions.componentSubmitAction(componentId, 'create'));
    },
    onReset: handleInit
  });
}

export var CreateForm = connect(null, mapDispatchToProps)(DataForm);